import styled from 'styled-components';
import academyStyles from './academy-styles';

const AcademyIconSvgCertification = (props) => {
  const defaultWidth = 16;
  const defaultHeight = 18;

  const { color, height = defaultHeight } = props;
  const calculatedWidth = (defaultWidth / defaultHeight) * height;

  return (
    <AcademyIconWrapper width={calculatedWidth} height={height}>
      <canvas width={calculatedWidth} height={height} />
      <svg width={calculatedWidth} height={height} viewBox="0 0 16 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" opacity="0.5">
          <g transform="translate(-1006.000000, -1949.000000)">
            <g transform="translate(980.000000, 1732.000000)">
              <g transform="translate(24.000000, 216.000000)">
                <path
                  d="M10.6708204,1.89442719 C10.2485292,1.68328157 9.75147084,1.68328157 9.32917961,1.89442719 L3.32917961,4.89442719 C3.07509159,5.0214712 2.86779668,5.21484188 2.72402379,5.44747131 C2.58025089,5.68010074 2.5,5.95198893 2.5,6.23606798 L2.5,13.763932 C2.5,14.0480111 2.58025089,14.3198993 2.72402379,14.5525287 C2.86779668,14.7851581 3.07509159,14.9785288 3.32917961,15.1055728 L9.32917961,18.1055728 C9.75147084,18.3167184 10.2485292,18.3167184 10.6708204,18.1055728 L16.6708204,15.1055728 C16.9249084,14.9785288 17.1322033,14.7851581 17.2759762,14.5525287 C17.4197491,14.3198993 17.5,14.0480111 17.5,13.763932 L17.5,6.23606798 C17.5,5.95198893 17.4197491,5.68010074 17.2759762,5.44747131 C17.1322033,5.21484188 16.9249084,5.0214712 16.6708204,4.89442719 L10.6708204,1.89442719 Z"
                  stroke={color || academyStyles.common.contentTypeIconColor}
                />
                <polygon
                  fill={color || academyStyles.common.contentTypeIconColor}
                  points="10 12.5 7.06107374 14.045085 7.62235871 10.7725425 5.24471742 8.45491503 8.53053687 7.97745751 10 5 11.4694631 7.97745751 14.7552826 8.45491503 12.3776413 10.7725425 12.9389263 14.045085"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </AcademyIconWrapper>
  );
};

export default AcademyIconSvgCertification;

const AcademyIconWrapper = styled.div`
  display: inline-block;
  position: relative;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  canvas {
    visibility: hidden;
  }
  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
  }
`;
